// extracted by mini-css-extract-plugin
module.exports = {"botonInicio":"inicio_botonInicio__2ifot","showButton":"inicio_showButton__AA4lF"};